import { memo } from 'react'
import styled from 'styled-components'

interface Props {
  isUseArea?: boolean
  isTooltipOpen: boolean
  text?: string
  children?: React.ReactNode
  className?: string
  label?: string
  onClick: () => void
}

interface TooltipWrapProps {
  $isTooltipOpen: boolean
}

const Tooltip = ({
  className,
  children,
  isUseArea = true,
  isTooltipOpen,
  text,
  label = 'tooltip label',
  onClick,
}: Props): JSX.Element => {
  return (
    <StyledContainer
      role="tooltip"
      aria-label={label}
      className={className}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <StyledTooltipWrap
        aria-label={`${label} content`}
        $isTooltipOpen={isTooltipOpen}
        onClick={() => !isUseArea && onClick()}
        role="presentation"
      >
        <StyledArrow />
        {text ? text : children ? children : ''}
      </StyledTooltipWrap>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  position: relative;
`
const StyledTooltipWrap = styled.div<TooltipWrapProps>`
  display: ${(props) => (props.$isTooltipOpen ? 'flex' : 'none')};
  justify-content: flex-end;
  position: absolute;
  left: -36px;
  right: 0;
  bottom: 0;
  top: calc(100% + 15px);
  white-space: pre-line;
  width: max-content;
  height: max-content;
  margin: 0 !important;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  z-index: 100;
  ${({ theme }) => theme.typography.description2}
`
const StyledArrow = styled.div`
  width: 50px;
  height: 25px;
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    width: 10px;
    height: 10px;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    background: white;
    border: 1px solid #d6d6d6;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
`

export default memo(Tooltip)
